import React$1 from 'react';

const Twitter = () => /*#__PURE__*/React$1.createElement("svg", {
  width: "40",
  height: "40",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React$1.createElement("path", {
  d: "M20 0c11.046 0 20 8.954 20 20s-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0zm5.04 11.331c-2.658 0-4.817 2.135-4.817 4.764 0 .375.04.741.13 1.087a13.726 13.726 0 01-9.936-4.98 4.73 4.73 0 001.5 6.354 4.776 4.776 0 01-2.18-.593v.059c0 2.312 1.66 4.23 3.869 4.674a4.857 4.857 0 01-2.18.08c.61 1.897 2.39 3.27 4.499 3.31a9.76 9.76 0 01-5.988 2.036c-.39 0-.77-.02-1.15-.07a13.54 13.54 0 007.368 2.155c8.866 0 13.714-7.264 13.714-13.559 0-.207 0-.415-.01-.612a9.813 9.813 0 002.409-2.471 9.87 9.87 0 01-2.77.751c1-.593 1.76-1.522 2.12-2.639-.93.544-1.96.94-3.059 1.157a4.822 4.822 0 00-3.518-1.503z",
  fill: "#FF005F",
  fillRule: "nonzero"
}));

export default Twitter;
